(() => {
  const page = document.querySelector('[data-faq-page]');
  if (!page) return;

  const sourceWrapper = page.querySelector('[data-faq-source]');
  const source = sourceWrapper?.querySelector('.rte');
  const enhanced = page.querySelector('[data-faq-enhanced]');
  if (!source || !enhanced) return;

  const normalize = (value) => value.replace(/\s+/g, ' ').trim();
  const sourceChildren = Array.from(source.children);
  const answersIndex = sourceChildren.findIndex((element) => /^answers:?$/i.test(normalize(element.textContent)));
  const questionsIndex = sourceChildren.findIndex((element) => /^questions:?$/i.test(normalize(element.textContent)));
  if (answersIndex < 0 || questionsIndex < 0) return;

  const categoryNames = new Map([
    ['online ordering & payment', 'Orders & payment'],
    ['digital gift cards', 'Digital gift cards'],
    ['mail order shipping', 'Shipping'],
    ['plants & plant care', 'Plants & plant care'],
    ['visiting the nursery', 'Visiting the nursery'],
  ]);

  const categories = [];
  let currentCategory = null;

  sourceChildren.slice(questionsIndex + 1, answersIndex).forEach((element) => {
    if (element.tagName === 'H4') {
      const sourceName = normalize(element.textContent).toLowerCase();
      const displayName = categoryNames.get(sourceName);
      currentCategory = displayName ? { name: displayName, questions: [] } : null;
      if (currentCategory) categories.push(currentCategory);
      return;
    }

    if (!currentCategory) return;
    element.querySelectorAll('a[href^="#"]').forEach((link) => {
      const slug = link.getAttribute('href').slice(1);
      const title = normalize(link.textContent);
      if (slug && slug !== 'top' && title) currentCategory.questions.push({ slug, title });
    });
  });

  const categoryOrder = ['Orders & payment', 'Shipping', 'Plants & plant care', 'Digital gift cards', 'Visiting the nursery'];
  categories.sort((first, second) => categoryOrder.indexOf(first.name) - categoryOrder.indexOf(second.name));

  const answerElements = sourceChildren.slice(answersIndex + 1);
  const directChildFor = (element) => {
    let current = element;
    while (current && current.parentElement !== source) current = current.parentElement;
    return current;
  };

  const cleanAnswer = (fragment, title) => {
    fragment.querySelectorAll('a[href="#top"], a[title="back to top"], a[name]').forEach((link) => {
      const parent = link.parentElement;
      link.remove();
      if (parent && !normalize(parent.textContent) && !parent.querySelector('img')) parent.remove();
    });
    fragment.querySelectorAll('hr').forEach((element) => element.remove());
    fragment.querySelectorAll('strong, h4').forEach((element) => {
      if (normalize(element.textContent).toLowerCase() === title.toLowerCase()) element.remove();
    });
    fragment.querySelectorAll('p, h4').forEach((element) => {
      if (!normalize(element.textContent) && !element.querySelector('img')) element.remove();
    });
    return fragment.innerHTML.trim();
  };

  categories.forEach((category) => {
    category.questions.forEach((question) => {
      const heading = answerElements
        .flatMap((element) => [element, ...element.querySelectorAll('strong, h4')])
        .find((element) => normalize(element.textContent).toLowerCase() === question.title.toLowerCase());

      if (!heading) {
        question.answer = '<p>Please contact the nursery for help with this question.</p>';
        return;
      }

      const headingBlock = directChildFor(heading);
      const startIndex = sourceChildren.indexOf(headingBlock);
      const fragment = document.createElement('div');

      for (let index = startIndex; index < sourceChildren.length; index += 1) {
        const element = sourceChildren[index];
        if (index > startIndex && (element.matches('h4') || element.querySelector('a[name]'))) break;
        fragment.appendChild(element.cloneNode(true));
      }

      question.answer = cleanAnswer(fragment, question.title) || '<p>Please contact the nursery for help with this question.</p>';
    });
  });

  if (!categories.length) return;

  const categoryNav = enhanced.querySelector('[data-faq-categories]');
  const heading = enhanced.querySelector('[data-faq-heading]');
  const results = enhanced.querySelector('[data-faq-results]');
  const empty = enhanced.querySelector('[data-faq-empty]');
  const search = enhanced.querySelector('[data-faq-search]');
  const expandButton = enhanced.querySelector('[data-faq-expand]');
  let activeCategory = categories[0].name;
  let query = '';

  const categoryButton = (category) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'faq-page__category';
    button.dataset.faqCategory = category.name;
    button.setAttribute('aria-pressed', String(category.name === activeCategory));
    button.innerHTML = `<strong>${category.name}</strong><small>${category.questions.length} ${category.questions.length === 1 ? 'question' : 'questions'}</small>`;
    return button;
  };

  categories.forEach((category) => categoryNav.appendChild(categoryButton(category)));

  const render = () => {
    const normalizedQuery = query.toLowerCase();
    const visibleCategories = query ? categories : categories.filter((category) => category.name === activeCategory);
    const matches = visibleCategories.flatMap((category) => category.questions
      .filter((question) => !query || `${question.title} ${question.answer}`.replace(/<[^>]+>/g, ' ').toLowerCase().includes(normalizedQuery))
      .map((question) => ({ ...question, category: category.name })));

    heading.textContent = query ? 'Search results' : activeCategory;
    results.replaceChildren();

    matches.forEach((question) => {
      const details = document.createElement('details');
      details.className = 'faq-page__item';
      details.id = question.slug;
      details.innerHTML = `<summary>${question.title}<span aria-hidden="true">+</span></summary><div class="faq-page__answer rte">${question.answer}</div>`;
      details.addEventListener('toggle', () => {
        details.querySelector('summary span').textContent = details.open ? '−' : '+';
      });
      results.appendChild(details);
    });

    empty.hidden = matches.length > 0;
    expandButton.hidden = matches.length === 0;
    expandButton.textContent = 'Expand all';
    categoryNav.querySelectorAll('[data-faq-category]').forEach((button) => {
      button.setAttribute('aria-pressed', String(!query && button.dataset.faqCategory === activeCategory));
    });
  };

  categoryNav.addEventListener('click', (event) => {
    const button = event.target.closest('[data-faq-category]');
    if (!button) return;
    activeCategory = button.dataset.faqCategory;
    query = '';
    search.value = '';
    render();
  });

  search.addEventListener('input', () => {
    query = normalize(search.value);
    render();
  });

  expandButton.addEventListener('click', () => {
    const details = Array.from(results.querySelectorAll('details'));
    const shouldExpand = details.some((item) => !item.open);
    details.forEach((item) => { item.open = shouldExpand; });
    expandButton.textContent = shouldExpand ? 'Collapse all' : 'Expand all';
  });

  enhanced.querySelectorAll('[data-faq-jump]').forEach((button) => {
    button.addEventListener('click', () => {
      const slug = button.dataset.faqJump;
      const category = categories.find((item) => item.questions.some((question) => question.slug === slug));
      if (!category) return;
      activeCategory = category.name;
      query = '';
      search.value = '';
      render();
      const item = results.querySelector(`#${CSS.escape(slug)}`);
      if (item) {
        item.open = true;
        item.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });

  sourceWrapper.hidden = true;
  enhanced.hidden = false;
  render();

  const initialSlug = window.location.hash.slice(1);
  if (initialSlug && initialSlug !== 'top') {
    const category = categories.find((item) => item.questions.some((question) => question.slug === initialSlug));
    if (category) {
      activeCategory = category.name;
      render();
      requestAnimationFrame(() => {
        const item = results.querySelector(`#${CSS.escape(initialSlug)}`);
        if (item) {
          item.open = true;
          item.scrollIntoView({ block: 'center' });
        }
      });
    }
  }
})();
